import { Button, Modal } from "react-bootstrap";

//Confirmation model popup
export function ConfirmationModal(props) {
  const {
    show,
    animate,
    ModalSize,
    SubmitButtonVariant,
    SubmitButtonClasses,
    SubmitButtonStyle,
    SubmitButtonText,
    CancelButtonVariant,
    CancelButtonClasses,
    CancelButtonText,
    onClose,
    Title,
    message,
    onConfirm,
    note,
    backdrop,
    selectedDateRange,
    modalBodyCssClassName,
    selectedDateRangeMessage,
    isBrandFeatureUpdate = false,
  } = props;

  return (
    <Modal
      show={show}
      onHide={onClose}
      size={ModalSize}
      backdrop={backdrop}
      animation={animate}
      className="react-survey-modal"
    >
      <div className="confirm-popup">
        <Modal.Header closeButton={!isBrandFeatureUpdate}>
          <Modal.Title>{Title}</Modal.Title>
        </Modal.Header>
      </div>
      <Modal.Body className={`pb-15 ${modalBodyCssClassName}`}>
        <p className={selectedDateRange && "h5"}>{message}</p>
        {selectedDateRange && (
          <>
            <div className="py-2 text-center fw-bold">{selectedDateRange}</div>
            <div className="px-3">
              <small>{selectedDateRangeMessage}</small>
            </div>
          </>
        )}

        {note && (
          <p>
            <b>Note: </b>
            {note}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={SubmitButtonVariant}
          className={SubmitButtonClasses}
          style={SubmitButtonStyle}
          onClick={(e) => {
            onConfirm(e);
          }}
        >
          {SubmitButtonText}
        </Button>

        <Button
          variant={CancelButtonVariant}
          className={CancelButtonClasses}
          onClick={onClose}
        >
          {CancelButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
